import React from "react";

export default function AppFormikInputInline(props) {
    const {
        formik,
        stFormClass,
        inputType,
        labelName,
        isRequired,
        isDisabled = false,
        placeholder,
        formikFieldName,
        value,
        error,
        style,
        onChange = () => { },

        currenceyIcon
    } = props;


    return (
        <div
            className={`st-form ${stFormClass || ""} ${(error || (formik?.touched[formikFieldName] && formik?.errors[formikFieldName]))
                ? "has-msg msg-error" : ""}`}
        >
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
                </label>
            ) : null}
            <div className="media-body st-form-input-container">
                <input
                    style={style}
                    type={inputType === "phone" ? "number" : (inputType ?? "text")}
                    className="form-control"
                    placeholder={placeholder}
                    id={formikFieldName}
                    {...formik?.getFieldProps(formikFieldName)}
                    onChange={(e) => {
                        formik?.setFieldValue(formikFieldName, e.target.value)
                        onChange(e)
                    }}
                    value={value || formik?.values[formikFieldName]}
                    disabled={isDisabled}
                />
                {
                    currenceyIcon ? (
                        <div className="currencey">
                            {currenceyIcon}
                        </div>
                    ) : null
                }

                {
                    /* form message */
                    (error || (formik?.touched[formikFieldName] &&
                        formik?.errors[formikFieldName])) && (
                        <div className="st-form-msg position-absolute">
                            <p className="st-fs-12">
                                {error || formik?.errors[formikFieldName]}
                            </p>
                        </div>
                    )
                }
            </div>
        </div>
    );
}
